module.exports = __webpack_public_path__ + "c55c417b7879d36777e5063a921aa330.png";